export const CONFIG_PRODUCTION = {
  NAME: "PRODUCTION",
  BASE_URL: `https://api.bicyclebluebook.com`,
  WEB_URL: `https://tradein-widget.bicyclebluebook.com`,
};
